import PropTypes from 'prop-types';
import React from 'react';
import { AutocompleteInput as ReactAdminAutocompleteInput, required as requiredFn } from 'react-admin';

export const AutocompleteInput = ({ isRequired, validate, ...props }) => (
  <ReactAdminAutocompleteInput
    {...props}
    validate={isRequired ? requiredFn() : validate}
  />
)

AutocompleteInput.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  validate: PropTypes.func,
};

AutocompleteInput.defaultProps = {
  sort: false,
  sortable: false,
  alwaysOn: true
};

export default AutocompleteInput;

